let scrollLocksCount = 0;

export const lockScroll = () => {
  if (scrollLocksCount === 0) {
    document.body.style.overflow = 'hidden';
  }
  ++scrollLocksCount;
};
export const unlockScroll = () => {
  if (scrollLocksCount === 1) {
    document.body.style.overflow = '';
  }
  if (scrollLocksCount > 0) {
    --scrollLocksCount;
  }
};
